type Props = {
  id: string;
  labelHtml: string;
  value: boolean;
  onChange: (v: boolean) => void;
  error?: string;
};

export function Consent({ id, labelHtml, value, onChange, error }: Props) {
  return (
    <div>
      <label htmlFor={id} className="consent">
        <input
          id={id}
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          aria-invalid={Boolean(error)}
        />
        <span dangerouslySetInnerHTML={{ __html: labelHtml }} />
      </label>
      {error && (
        <div className="field-error" role="alert" style={{ marginTop: 8 }}>
          {error}
        </div>
      )}
    </div>
  );
}
